import type { CompanyContact } from '@/api/v4/organization-contacts.api';

export const sortContactsByPrimaryAndFirstName = (
  contacts: CompanyContact[],
) => {
  return contacts.sort((a, b) => {
    if (a.isPrimary && !b.isPrimary) {
      return -1;
    } else if (!a.isPrimary && b.isPrimary) {
      return 1;
    }

    const firstNameCompare = a.firstName.localeCompare(b.firstName);
    if (firstNameCompare !== 0) {
      return firstNameCompare;
    }

    return a.lastName.localeCompare(b.lastName);
  });
};
